import { MyleTableColumn, MyleTableColumnOptions } from "@/Common/Components/Tables/MyleTableColumn";
import { TableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { ValueSetType } from "../Constants/ValueSetType";
import { ImmunizationModel } from "../Models/ImmunizationModel";
import { QuebecVaccinationRegistryHelper } from "../QuebecVaccinationRegistryHelper";
import { BaseImmunizationTable, BaseImmunizationTableProps } from "./BaseImmunizationTable";

class NonValidImmunizationsSummaryTable extends BaseImmunizationTable<BaseImmunizationTableProps<ImmunizationModel>, ImmunizationModel> {
    protected title(): string {
        return cacheStore.GetString("QuebecVaccinationRegistry_InvalidVaccinationSummariesLabel");
    }

    protected tableId(): string {
        return "non-valid-immunization-summary";
    }

    private labels = {
        ImmunizationAgent: "QuebecVaccinationRegistry_AntigenImmunizingAgentLabel",
        AdministrationDate: "AdministeredDateDLabel",
        InvalidationReason: "QuebecVaccinationRegistry_ReasonForInvalidationLabel"
    };

    private fieldNames = {
        ImmunizationAgent: "ImmunizationAgent",
        AdministrationDate: "AdministrationDate",
        InvalidationReason: "InvalidationReason"
    };

    protected defaultTableOptions(): Immutable.List<MyleTableColumnOptions> {
        return Immutable.List([
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString(this.labels.ImmunizationAgent),
                FieldName: this.fieldNames.ImmunizationAgent,
                WidthPercentageDefault: 34
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString(this.labels.AdministrationDate),
                FieldName: this.fieldNames.AdministrationDate,
                WidthPercentageDefault: 33
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString(this.labels.InvalidationReason),
                FieldName: this.fieldNames.InvalidationReason,
                WidthPercentageDefault: 33
            })
        ]);
    }

    protected getTableColumns(tableOptions: Immutable.List<MyleTableColumnOptions>): Immutable.List<MyleTableColumn> {
        return MyleTableColumn.buildList<TableDataSourceItem<ImmunizationModel>>(
            tableOptions,
            column => {
                switch (column.FieldName) {
                    case this.fieldNames.ImmunizationAgent:
                        return {
                            renderCell: item => <div>{QuebecVaccinationRegistryHelper.translateValueSetString(item.Model.Vaccine, ValueSetType.Agent)}</div>
                        };

                    case this.fieldNames.AdministrationDate:
                        return {
                            renderCell: item => <div>{this.formatDate(item.Model.Date)}</div>
                        };

                    case this.fieldNames.InvalidationReason:
                        return {
                            renderCell: item => <div>{QuebecVaccinationRegistryHelper.translateValueSetString(item.Model.OverrideReason, ValueSetType.OverrideReason)}</div>
                        };
                }
            },
            false
        );
    }
}

export { NonValidImmunizationsSummaryTable };
